<template>
    <div class="service--common">
        <b-row>
            <b-col cols="10" offset="1">
                <div class="service--common--panel">
                    <div class="service--common--head">
                        <div class="toggle service--toggle" v-b-toggle="'service-common-'+_uid" v-html="chevron_down_toggler"></div>
                        <label>
                            Dettagli, descrizioni, condizioni
                        </label>
                    </div>
                    <b-collapse class="service--collapse" :id="'service-common-'+_uid"><!--accordion="quote-accordion"-->
                        <public-data :service_index="service_index" :public_data="public_data" />
                        <hr />
                        <private-data :service_index="service_index" :private_data="private_data" />
                    </b-collapse>
                </div>
            </b-col>
        </b-row>
    </div>    
</template>

<script>
    import ServicePublicData from '@/components/blocks/service-public-data'
    import ServicePrivateData from '@/components/blocks/service-private-data'
    import { chevron_down_toggler } from '@/components/svg/common'
    export default {
        name: 'service-common',
        components: {
            'public-data': ServicePublicData,
            'private-data': ServicePrivateData,
        },
        created()
        {
            this.chevron_down_toggler = chevron_down_toggler
        },
        props:
        {
            service_index: Number,
            public_data: Object,
            private_data: Object,
        }
    }
</script>

<style lang="scss">
    .service--common
    {
        &--panel
        {
            @include subpanel;
            background:rgba($gray-300,0.5);
        }
        margin-top:$grid-gutter-width/2;
        &--block
        {
            margin-top:$grid-gutter-width/2;
            border-radius: $border-radius;
            .alert
            {
                margin-bottom:0;
            }
        }
        &--head
        {
            display: flex;
            align-items: center;
            label
            {
                min-width: auto;
                margin-left:1rem;
                margin-bottom: 0;
            }
        }
        .collapse
        {
            margin-top:1.5rem;
        }
        .private-data,
        .public-data
        {
            @extend .service--common--block !optional;
            .form-group
            {
                margin-bottom:0;
            }
        }
    }
</style>